import PostRequest from "../../services/PostRequest";

export const GET_OUTPUT_LIST = "GET_OUTPUT_LIST";
export const GET_MORE_OUTPUT_LIST = "GET_MORE_OUTPUT_LIST";

export const getDownloadOutputList = (data, isMoreOutputList = false) => {
  return async (dispatch) => {
    try {
      const response = await PostRequest("/results/collections/results/download/", data);

      if (isMoreOutputList) {
        dispatch({
          type: GET_MORE_OUTPUT_LIST,
          value: response,
        });
      } else {
        dispatch({
          type: GET_OUTPUT_LIST,
          value: response,
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  };
};
